document.addEventListener('DOMContentLoaded', function () {
	const sliderTpl = document.getElementById('sponsorSlider');

	const breakpoints = [
		{ width: 0, itemsToShow: 3 },
		{ width: 576, itemsToShow: 4 },
		{ width: 768, itemsToShow: 5 },
		{ width: 992, itemsToShow: 6 },
		{ width: 1200, itemsToShow: 7 },
	];
	const initSlider = () => {
		let existingItemsToShow = null;
		if (sliderTpl.nextElementSibling) {
			existingItemsToShow = sliderTpl.nextElementSibling.dataset.itemsToShow || null;
		}

		let itemsToShow = 1;
		const width = window.innerWidth;
		breakpoints.forEach((bp) => {
			if (width >= bp.width) {
				itemsToShow = bp.itemsToShow;
			}
		});

		if (existingItemsToShow !== null && parseInt(existingItemsToShow) === itemsToShow) {
			// No need to re-initialize
			return;
		}

		if (sliderTpl.nextElementSibling) {
			sliderTpl.nextElementSibling.remove();
		}
		const slider = sliderTpl.cloneNode(true);
		slider.removeAttribute('id');
		sliderTpl.after(slider);
		slider.dataset.itemsToShow = itemsToShow;

		let items = slider.querySelectorAll('.carousel-item')
		items.forEach((el) => {
			let next = el.nextElementSibling
			for (let i = 1; i < itemsToShow; i++) {
				if (!next) {
					// wrap carousel by using first child
					next = items[0]
				}
				let cloneChild = next.cloneNode(true)
				el.appendChild(cloneChild.children[0])
				next = next.nextElementSibling
			}
		});
		$(slider).carousel();
	}

	if (sliderTpl) {
		initSlider();

		window.addEventListener('resize', initSlider);
	}

});

